import { Pipe, PipeTransform } from '@angular/core';
import { BaseAccount } from '@shared/models';

@Pipe({
  name: 'accountDisplayName',
})
export class AccountDisplayNamePipe implements PipeTransform {
  transform(account: BaseAccount, initialsOnly = false): any {
    if (!account) {
      return null;
    }

    return initialsOnly
      ? this.getInitials(account)
      : `${account.firstName} ${account.lastName}`;
  }

  private getInitials(account: BaseAccount): string {
    let result = '';

    if (!account) {
      return result;
    }

    if (account.firstName && account.firstName.length) {
      result += account.firstName[0];
    }

    if (account.lastName && account.lastName.length) {
      result += account.lastName[0];
    }

    return result;
  }
}
